<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Sistemos pranešimai') }}</h1>
    <!-- add button  -->
    <el-button
      class="mb-5"
      color="primary"
      icon="pridėti"
      title="Pridėti naują"
      :loading="loading"
      @click.native.stop="newItem()"
    />
    <!-- search -->
    <admin-system-notifications-search
      :loading="loading"
      @search="searchNotifications"
    />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.applications`]="{ item }">
        <el-table-enum enumName="application" list :item="item.applications" />
      </template>
      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @deleteItem="deleteItem(item)"
          />
        </div>
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import AdminSystemNotificationsSearch from './AdminSystemNotificationsSearch'
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import Enums from '@/enums'
import tableParameters from '@/mixins/tableParameters'

export default {
  name: 'SystemNotifications',
  components: {
    AdminSystemNotificationsSearch,
    ModalDelete,
  },
  mixins: [userRole, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      listData: [],
      searchData: {},
      tableClassifiers: [],
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Kodas'),
          align: 'start',
          value: 'code',
        },
        {
          text: this.$t('Sistemos pranešimo pavadinimas'),
          align: 'start',
          value: 'title',
        },
        {
          text: this.$t('Pranešimo rodymo laikas (ribojimas nuo) nuo'),
          align: 'start',
          value: 'valid_from',
        },
        {
          text: this.$t('Pranešimo rodymo laikas (ribojimas nuo) iki'),
          align: 'start',
          value: 'valid_to',
        },
        {
          text: this.$t('Pranešimas rodomas'),
          align: 'start',
          value: 'applications',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    // this.setlistParams()
  },
  methods: {
    newItem() {
      this.$router.push({
        name: 'adminSystemNotificationForm',
      })
    },
    getData(resetPageNr = false) {
      this.tableClassifiers = Enums
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`system-notifications/list`, data)
        .then((res) => {
          this.listData = res.data.systemNotifications
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchNotifications(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },

    editItem(item, mode) {
      this.$router.push({
        name: 'adminSystemNotificationForm',
        params: {
          id: item.id,
        },
      })
    },

    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },

    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`system-notifications/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
